module.exports = __webpack_public_path__ + "static/digital-marketing-ccd96128300c6a981f47ab8ed21b8b8a.png";